import React, { useState } from "react";
import { Box } from "@material-ui/core";
import { PAGE_TRANSITIONS, normalizePageTransitionId } from "./escapeRoomEditorConstants";
import PageTransitionPreview from "./PageTransitionPreview";

export default function PageTransitionPicker({ value = "none", onChange, helperText }) {
	const activeId = normalizePageTransitionId(value || "none");
	const [hoveredId, setHoveredId] = useState(null);

	return (
		<>
			{helperText ? (
				<Box fontSize={11} color="#94a3b8" mb={1.5} lineHeight={1.35}>
					{helperText}
				</Box>
			) : null}
			<Box
				display="grid"
				style={{
					gridTemplateColumns: "repeat(auto-fill, minmax(132px, 1fr))",
					gap: 10,
					maxHeight: 340,
					overflowY: "auto",
					paddingRight: 2,
				}}
			>
				{PAGE_TRANSITIONS.map((t) => {
					const active = activeId === t.id;
					const playing = active || hoveredId === t.id;
					const Icon = t.Icon;
					return (
						<Box
							key={t.id}
							role="button"
							tabIndex={0}
							onClick={() => onChange(t.id)}
							onMouseEnter={() => setHoveredId(t.id)}
							onMouseLeave={() => setHoveredId((prev) => (prev === t.id ? null : prev))}
							onKeyDown={(e) => {
								if (e.key === "Enter" || e.key === " ") {
									e.preventDefault();
									onChange(t.id);
								}
							}}
							style={{
								borderRadius: 12,
								border: active ? "2px solid #7c3aed" : "1px solid #e2e8f0",
								background: "#fff",
								padding: 8,
								cursor: "pointer",
								boxShadow: active ? "0 0 0 3px rgba(124,58,237,0.12)" : "0 1px 3px rgba(0,0,0,0.04)",
								transition: "border-color 0.15s, box-shadow 0.15s",
							}}
						>
							<Box display="flex" alignItems="center" justifyContent="center" mb={0.5} style={{ gap: 4, minHeight: 22 }}>
								{Icon ? <Icon style={{ fontSize: 16, color: active ? "#7c3aed" : "#64748b" }} /> : null}
								<Box
									fontSize={10}
									fontWeight={700}
									color={active ? "#5b21b6" : "#64748b"}
									lineHeight={1.2}
									textAlign="center"
								>
									{t.label}
								</Box>
							</Box>
							<PageTransitionPreview transitionId={t.id} playing={playing} />
						</Box>
					);
				})}
			</Box>
		</>
	);
}
